import { ImageField } from '@prismicio/client';
import { memo } from 'react';

import { OptimizedPrismicImage } from '@/components';
import styles from './serviceImage.module.scss';

interface ServiceImageProps {
  image: ImageField<never>;
  isActive: boolean;
}

const ServiceImageComponent = ({ image, isActive }: ServiceImageProps) => {
  return (
    <li
      key={image.id}
      className={`${styles.image_item} ${isActive ? styles.visible : styles.hidden}`}
    >
      <OptimizedPrismicImage field={image} className={styles.image} />
    </li>
  );
};

export const ServiceImage = memo(ServiceImageComponent);
